//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/** @jsxImportSource @emotion/react */

export const resourcesStyles = {
  container: {
    marginTop: '7vh',
    backgroundColor: '#F5F5FA',
    flex: 1,
  },
  title: {
    marginLeft: '4.2vh',
    paddingTop: '2vh',
    fontFamily: 'Inter',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '2.2vw',
    color: '#1D1D23',
    paddingBottom: '1.6vh',
  },
  cardMain: {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: '5vh',
  },
  cardStructure: {
    width: '35.8vh',
    height: '280px',
    display: 'flex',
    marginLeft: '4.2vh',
    marginBottom: '4.1vh',
  },
  cardtitle: {
    height: '2.2vh',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '20px',
    paddingTop: '1.6vh',
    paddingBottom: '20px',
  },
  cardButtonStructure: {
    display: 'flex',
    width: '100%',
  },
  cardButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '16px',
    borderBottom: '1px solid #C8C8DD',
    marginBottom: '1vh',
    padding: '0.5vh',
    paddingBottom: '10px',
    textDecoration: 'none',
    color: '#0550DC',
  },
  image: {
    width: '55px',
    height: '35px',
  },
};
